// extracted by mini-css-extract-plugin
export default {"body":"Forms_body__eEquO","btn":"Forms_btn__J+VXn"};